import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function ThankYou() {
  return (
    <>
      <Row className="text-center mt-5">
        <Col>
          Thank you for your submission
        </Col>
      </Row>
    </>
  );
}

export default ThankYou;
